// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".front-page .module__container[data-v-06362b70]:first-child{padding-top:10vh;padding-bottom:7vh}@media only screen and (max-width:599.98px){.front-page .module__container[data-v-06362b70]:first-child{padding-top:0;padding-bottom:2vh}}", ""]);
// Exports
module.exports = exports;
